import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const useGetTranslation = () => {
    const intl = useIntl();
    const getTranslation = useCallback((id, values, options) => {
        const translated = intl.formatMessage({ id }, values, options);
        return translated === id ? '' : translated;
    }, [intl]);
    return getTranslation;
};
//# sourceMappingURL=useGetTranslation.js.map